import { getFormDefinition, createFormDataFromItem, createItemFromFormData } from './form';
import { entityToStore } from '@/utils/store';
import baseCrudMixin from '@/mixins/crud';
import { FabricStatusOption } from '@/utils/constants';
import { ConvertMillimetersToCentimeters } from '@/utils/converters';

export default {
  computed: {
    definition() {
      return this.createDefinition();
    },
    entityStore() {
      return entityToStore(this.entity);
    },
    ownProductYN() {
      return this.$store.getters['editor/value']('ownProductYN');
    },
    domainID() {
      return this.$store.getters['editor/value']('domainID');
    },
    defaultCuttingWastePercentage() {
      return +this.$store.getters['configuration/value']('fabric.cuttingWastePercentage');
    },
    defaultPartsPerHanger() {
      return +this.$store.getters['configuration/value']('fabric.defaultPartsPerHanger');
    },
    defaultDefaultLockSeamWidthInCm() {
      return ConvertMillimetersToCentimeters(
        +this.$store.getters['configuration/value']('fabric.defaultLockSeamWidthInMm')
      );
    },
    requiredFieldsMustBeSet() {
      const fabricStatusOption = this.$store.getters['editor/value']('fabricStatusOption');
      return typeof fabricStatusOption !== 'undefined' && fabricStatusOption !== FabricStatusOption.New;
    }
  },
  watch: {
    domainID(newDomainID, oldDomainId) {
      if (newDomainID && oldDomainId && newDomainID !== oldDomainId) {
        this.injectFormValues = Object.assign({}, { collections: [] });
        this.injectFormValues = Object.assign({}, { consumerPrices: [] });
      }
    }
  },
  mixins: [baseCrudMixin],
  data: () => ({
    entity: 'Fabric',
    returnTo: 'Fabrics',
    injectFormValues: {}
  }),
  async created() {
    await Promise.all([
      this.$store.dispatch('yarn/getItems'),
      this.$store.dispatch('productType/getItems'),
      this.$store.dispatch('product/getItems'),
      this.$store.dispatch('workshop/getItems'),
      this.$store.dispatch('collection/getItems'),
      this.$store.dispatch('finish/getItems'),
      this.$store.dispatch('currency/getItems')
    ]);
  },
  methods: {
    createDefinition() {
      return getFormDefinition(this);
    },
    createHeaderText(description, domainProductCode) {
      let header = description || '';
      if (domainProductCode) {
        header += ' - ' + domainProductCode;
      }
      return header;
    },
    inheritedValuePlaceholder(value) {
      return value !== null && typeof value !== 'undefined' ? value.toString() : '';
    },
    inheritedValueFromProductGroupToolTip(source, productGroupName) {
      const sourceName = this.$i18n.t(`fabric.source${source}`);
      return this.$i18n.t('fabric.takeOverFromProductGroupToolTip', { sourceName, productGroupName });
    },
    inheritedValueFromSettingsToolTip(settingsCode) {
      const configItem = this.$store.getters['configuration/loadedItems'].find(c => c.code === settingsCode);
      return this.$i18n.t('fabric.takeOverFromSettingsToolTip', { settingsName: configItem && configItem.description });
    },
    createFormDataFromItem,
    createItemFromFormData
  }
};
